import { FC } from "react";
import { Row, Spin, Typography } from "antd";

import { classname, Optional } from "@ctra/utils";

import styles from "./NumericValue.module.less";

const { Text } = Typography;

export interface NumericValueProps {
  /**
   * loading
   */
  isLoading?: boolean;
  /**
   * numeric value
   */
  value: Optional<number>;
  /**
   * unit
   */
  unit: string;
  /**
   * highlight in blue
   */
  highlighted?: boolean;
}

/**
 * NumericValue component
 * @param isLoading
 * @param value
 * @param unit
 * @param highlighted
 */
const NumericValue: FC<NumericValueProps> = ({ isLoading, value, unit, highlighted }) => {
  return (
    <Row align="bottom">
      <Text className={classname(styles.Text, highlighted ? styles.Highlighted : "")}>
        {isLoading ? (
          <Spin />
        ) : value ? (
          <>
            {value}
            <Text className={styles.Unit}>{unit}</Text>
          </>
        ) : (
          <Row justify="center">-</Row>
        )}
      </Text>
    </Row>
  );
};

export default NumericValue;
